
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function przeniesWykonanie(wykonanieId,grupaIdDrop,fechparametryTechnologii,zamowienie_id,technologia_id,generujPolaczenia) {



  axios.get(IP + "API_0020_gant_procedura_przenies_wykonanie_gold/"+wykonanieId+"/"+grupaIdDrop+"/"+sessionStorage.getItem("token"))
    .then((res) => {
      // let technologia_id =res.data[0].technologia_id

 fechparametryTechnologii(zamowienie_id,technologia_id)
    // fechparametryTechnologii(zamowienie_id,res.data[0].technologia_id)

    
    }).then((res) => {
generujPolaczenia( technologia_id)
    });
}